declare namespace $ {

	type $shm_echarts__option_shm_agent_message_chart_1 = $mol_type_enforce<
		ReturnType< $shm_agent_message_chart['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	export class $shm_agent_message_chart extends $mol_view {
		height_style( ): string
		Chart( ): $shm_echarts
		option( ): any
		height( ): number
		style( ): ({ 
			'height': ReturnType< $shm_agent_message_chart['height_style'] >,
		})  & ReturnType< $mol_view['style'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chart.view.tree.d.ts.map